//
import Model from '@/models/Model'

/**
 * This class describes a sl detail sale invoice.
 * @class      SlDetailSaleInvoice (name)
 */
export default class SlDetailSaleInvoice extends Model {

	/**
	 * { property_description }
	 * @type       {<type>}
	 */
	get wh_product_internal_code() { 
		return this.getProperty('wh_product.internal_code') 
	}

	/**
	 * { property_description }
	 * @type       {<type>}
	 */
	get wh_product_name() { 
		return this.getProperty('wh_product.name') 
	}

	/**
	 * { function_description }
	 * @return     {string}  { description_of_the_return_value }
	 */
  resource() { 
  	return 'sl_detail_sale_invoice' 
  }
}